import PropTypes from 'prop-types';

const DEFAULT_VARIANT = 'default';
const NO_VALUE_VARIANT = 'no_value';
const SAVINGS_POTENTIAL_VARIANT = 'savings_potential';
const SEE_YOUR_OFFERS_VARIANT = 'see_your_offers';
const START_FREE_CHECK_VARIANT = 'start_free_check';
export const ICON_VARIANT = 'icon';
export const ICON_COLOR_VARIANT = 'icon_color';
export const COLOR_VARIANT = 'color';

export const DIMENSION_NAMES = {
  COPY_SHOP_3751: 'copyShop3751',
  CTA_SHOP_3751: 'ctaShop3751',
  DESIGN_SHOP_3751: 'designShop3751',
};

export const defaultDimensions = {
  [DIMENSION_NAMES.COPY_SHOP_3751]: DEFAULT_VARIANT,
  [DIMENSION_NAMES.CTA_SHOP_3751]: DEFAULT_VARIANT,
  [DIMENSION_NAMES.DESIGN_SHOP_3751]: DEFAULT_VARIANT,
};

const eligibilityValuesForDimensions = {
  [DIMENSION_NAMES.COPY_SHOP_3751]: [NO_VALUE_VARIANT, SAVINGS_POTENTIAL_VARIANT],
  [DIMENSION_NAMES.CTA_SHOP_3751]: [SEE_YOUR_OFFERS_VARIANT, START_FREE_CHECK_VARIANT],
  [DIMENSION_NAMES.DESIGN_SHOP_3751]: [ICON_VARIANT, ICON_COLOR_VARIANT, COLOR_VARIANT],
};

const getConfigForDimension = (dimensionName, dimensionValue) => {
  if (dimensionName === DIMENSION_NAMES.COPY_SHOP_3751) {
    return {
      isNoValueCopy: [NO_VALUE_VARIANT].includes(dimensionValue),
      isSavingsPotentialCopy: [SAVINGS_POTENTIAL_VARIANT].includes(dimensionValue),
    };
  }

  if (dimensionName === DIMENSION_NAMES.CTA_SHOP_3751) {
    return {
      ctaCopy: [SEE_YOUR_OFFERS_VARIANT].includes(dimensionValue) ? 'See Your Offers' : 'Start Free Check',
    };
  }

  if (dimensionName === DIMENSION_NAMES.DESIGN_SHOP_3751) {
    return {
      withIcon: [ICON_VARIANT].includes(dimensionValue),
      withIconColor: [ICON_COLOR_VARIANT].includes(dimensionValue),
      withColor: [COLOR_VARIANT].includes(dimensionValue),
    };
  }

  return {};
};

export const isEligibleDimension = (dimensionName, dimensionValue) =>
  Object.values(DIMENSION_NAMES).includes(dimensionName) &&
  dimensionValue !== defaultDimensions[dimensionName] &&
  eligibilityValuesForDimensions[dimensionName].includes(dimensionValue);

export const getDimensionsConfig = dimensions =>
  Object.entries(dimensions).reduce((config, [dimensionName, dimensionValue]) => {
    if (!isEligibleDimension(dimensionName, dimensionValue)) {
      return { ...config, [dimensionName]: {} };
    }
    return { ...config, [dimensionName]: getConfigForDimension(dimensionName, dimensionValue) };
  }, {});

export const Shop3751CopyEntity = PropTypes.shape({
  isNoValueCopy: PropTypes.bool,
  isSavingsPotentialCopy: PropTypes.bool,
});

export const Shop3751CtaEntity = PropTypes.shape({
  ctaCopy: PropTypes.string,
});

export const Shop3751DesignEntity = PropTypes.shape({
  withIcon: PropTypes.bool,
  withIconColor: PropTypes.bool,
  withColor: PropTypes.bool,
});

export const Shop3751AxConfigEntity = PropTypes.shape({
  copyShop3751: Shop3751CopyEntity,
  ctaShop3751: Shop3751CtaEntity,
  designShop3751: Shop3751DesignEntity,
});

export const Shop3751DefaultValue = {};

export const Shop3751AxConfigDefaultValues = {
  copyShop3751: Shop3751DefaultValue,
  ctaShop3751: Shop3751DefaultValue,
  designShop3751: Shop3751DefaultValue,
};
